export default __webpack_public_path__ + "static/media/trailer-size-guide.0750dffe.png";